export { TabViewModule } from './tabview.module';
export { TabViewRoutes } from './tabview.routes';